import React from 'react';
import { Result } from 'antd';

// ============================================================================
// COMPONENTES E UI
// ============================================================================
import { Button } from 'components/ds';

// ============================================================================
// ESTILOS
// ============================================================================
import { Container, Title, SubTitle, ButtonStyle } from './Construction.styles';

// ============================================================================
// COMPONENTE
// ============================================================================

const Construction: React.FC = () => (
  <Container>
    <Result
      status="500"
      title={<Title>Página em Construção</Title>}
      subTitle={
        <SubTitle>
          Esta página está temporariamente indisponível pois está em desenvolvimento. 
          Por favor, tente novamente mais tarde.
        </SubTitle>
      }
      extra={[
        <Button 
          key="retry"
          type="highlight" 
          onClick={() => window.location.href = '/'}
          size="large"
          style={ButtonStyle}
        >
          Atualizar Página
        </Button>
      ]}
    />
  </Container>
);

export default Construction;
